module.exports = __webpack_public_path__ + "static/media/Messages.9a6408c7.jpg";